import * as notifier from './notifier';
import * as coverage from '../xhr/coverage';
import * as types from './types/coverage';

/**
 * @param dispatch
 * @param state
 */
function setLoading(dispatch, state) {
    dispatch({
        type: types.LOADING,
        state
    });
}

/**
 * @returns {function(*=): Promise<any | never>}
 */
export function sendQuery(query) {
    return (dispatch) => {
        setLoading(dispatch, true);

        return coverage
            .sendQuery(query)
            .then((response) => {
                setLoading(dispatch, false);
                return response;
            })
            .catch((error) => {
                setLoading(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}